import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
const echarts = require('echarts');
var nzhcn = require("nzh/cn");
import './api/axios'
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$echarts = echarts
Vue.prototype.$nzhcn = nzhcn

Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

new Vue({
  router,
  mode: 'hash',
  render: h => h(App),
}).$mount('#app')